import { render, staticRenderFns } from "./MarketplaceCard.vue?vue&type=template&id=51669dcc&scoped=true&"
import script from "./MarketplaceCard.vue?vue&type=script&lang=js&"
export * from "./MarketplaceCard.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceCard.vue?vue&type=style&index=0&id=51669dcc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51669dcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
